module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"send":"Отправить","placeholder":"Введите сообщение","chatTitle":"Чат"}}')
  delete Component.options._Ctor
}
